import {Loader, PassportUser, useTransition} from '@logistics-frontend/blocks'
import React from 'react'

import {fetchAllAccountsDeprecated} from '../../api'
import {appConfig, i18n} from '../../config'

type UserProps = {
  isMobile?: boolean
}

function User({isMobile = false}: UserProps): React.ReactElement<UserProps> | null {
  const [{payload, isPending}] = useTransition(fetchAllAccountsDeprecated, {
    key: 'fetch/accounts',
  })

  if (isPending) {
    return <Loader size="m" />
  }

  if (payload) {
    return (
      <PassportUser
        addUserText={i18n('passport.user.adduser')}
        avatarHost={appConfig.avatarsHost}
        mobile={isMobile}
        passport={payload}
        passportHost={appConfig.passportHost}
        returnPath={encodeURIComponent(window.location.href)}
        signInText={i18n('passport.user.signin')}
        signOutText={i18n('passport.user.signout')}
        yui={appConfig.yandexuid}
      />
    )
  }

  return null
}

export default React.memo(User) as typeof User
